// Oversized, low-opacity decorative background word used behind section
// headers to add editorial depth without competing with foreground content.
export const Watermark = ({ word, position = "top-right", className = "" }) => {
  const positions = {
    "top-right": "-top-6 sm:-top-10 right-[-10px] sm:right-4 text-right",
    "top-left": "-top-6 sm:-top-10 left-[-10px] sm:left-4 text-left",
    "bottom-right": "bottom-[-10px] sm:bottom-0 right-[-10px] sm:right-4 text-right",
    "bottom-left": "bottom-[-10px] sm:bottom-0 left-[-10px] sm:left-4 text-left",
    center: "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center",
  };

  return (
    <span
      aria-hidden="true"
      className={`watermark-text text-[64px] sm:text-[100px] lg:text-[140px] ${positions[position] || positions["top-right"]} ${className}`}
    >
      {word}
    </span>
  );
};
